import Home from '../pages/Home';
import Login from '../pages/Login';
import Test from '../pages/Test';
import Registration from '../pages/Registration';
import Maintenance from '../pages/Maintenance';

export default [
  {
    path: '/',
    name: 'Home',
    component: Home,
    props: route => ({ reload: route.query.reload })
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Registration
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: Maintenance
  },
  {
    path: '/test',
    name: 'Test',
    component: Test
  }
];
